import { Expose } from 'class-transformer'

import { ConditionType } from '../../types'
import LabelCondition from './SetPropertyCondition'

export default class IsNotSetPropertyCondition extends LabelCondition {
  type!: ConditionType.IsNotSetProperty
}
